import ReportAsync from './ReportAsync';
import { ReportAsyncGroup } from './ReportAsync/types';

const ReportSIES = () => {
  return <ReportAsync group={ReportAsyncGroup.SIES} />;
};

export default ReportSIES;
